<section class="cmn-innerpage-wrapper">
  <div class="head">
    <h1>Video Story</h1>
    <div class="head-div">
      <div class="search-wrapper">
        <input
          type="text"
          class="cmn-header-search"
          placeholder="Search Video Stories"
          (input)="onSearch($event)"
        />
      </div>
      <button
        *appHasPermission="'ADD_VIDEO_STORY'"
        (click)="onAddVideoStory()"
        class="cmn-add-btn"
      >
        <img src="assets/images/icons/icon-add.svg" alt="Add icon" /> Add Video
      </button>
    </div>
  </div>
  <div class="itemListWrapper" *ngIf="!loading">
    <div class="itemWrapper" *ngFor="let story of storyList">
      <div class="story-img-wrapper">
        <img
          [src]="
            story.thumbURL || '../../../assets/images/placeHolderImage.jpg'
          "
          alt="StoryImage"
          (error)="onImageError($event)"
        />
      </div>
      <div class="action-Container">
        <h3 class="cmn-list-title">
          {{ getTranslationName(story).slice(0, 40) }}
        </h3>

        <div class="action-wrapper">
          <div (click)="openDialog(story.videoLink)" class="iconWrapper">
            <img src="../../../assets/images/icons/icon-eye-open.svg" alt="" />
          </div>
          <div
            *appHasPermission="'DELETE_VIDEO_STORY'"
            (click)="deleteVideoStory(story.id)"
            class="iconWrapper"
          >
            <img src="../../../assets/images/icons/icon-delete.svg" alt="" />
          </div>
          <div
            *appHasPermission="'UPDATE_VIDEO_STORY'"
            (click)="editVideoStory(story.id)"
            class="iconWrapper"
          >
            <img src="../../../assets/images/icons/icon-edit.svg" alt="" />
          </div>
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="noData">
    <app-no-data-component></app-no-data-component>
  </div>
  <app-content-loader [visible]="loading"></app-content-loader>
</section>
